import React from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const PagoExitoso = () => {
  const [params] = useSearchParams();
  const paymentId   = params.get("payment_id");
  const externalRef = params.get("external_reference");
  const tipo        = params.get("tipo");
  const id          = params.get("id");

  const handleVolver = () => {
    if (tipo && id) {
      window.location.href = `/?tipo=${encodeURIComponent(tipo)}&id=${encodeURIComponent(id)}`;
    } else {
      window.location.href = "/";
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center border border-green-100">
        <div className="flex justify-center mb-6">
          <CheckCircle2 className="w-20 h-20 text-green-500" />
        </div>
        <h1 className="text-3xl font-bold text-green-700 mb-2">¡Pago Exitoso!</h1>
        <p className="text-gray-500 mb-6">Tu pago fue procesado correctamente.</p>

        <div className="bg-green-50 rounded-xl p-4 text-left space-y-2 mb-4 border border-green-200">
          {paymentId && (
            <div className="flex justify-between text-sm">
              <span className="text-gray-500 font-medium">N° de pago:</span>
              <span className="font-bold text-gray-800">{paymentId}</span>
            </div>
          )}
          {externalRef && (
            <div className="flex justify-between text-sm">
              <span className="text-gray-500 font-medium">Boleta(s):</span>
              <span className="font-bold text-gray-800">{externalRef}</span>
            </div>
          )}
          <div className="flex justify-between text-sm">
            <span className="text-gray-500 font-medium">Estado:</span>
            <span className="font-bold text-green-600">Aprobado</span>
          </div>
        </div>

        <div className="bg-amber-50 rounded-xl p-4 text-left mb-6 border border-amber-200">
          <p className="text-sm text-amber-800 font-semibold mb-1">⏳ Pendiente de acreditación</p>
          <p className="text-xs text-amber-700">
            El pago fue recibido y está siendo procesado por Tesorería Municipal.
            La boleta quedará bloqueada hasta su acreditación oficial.
            Guardá el número de pago como comprobante.
          </p>
        </div>

        <button
          onClick={handleVolver}
          className="block w-full bg-gradient-to-r from-blue-600 to-sky-500 text-white font-semibold py-3 rounded-xl hover:from-blue-700 hover:to-sky-600 transition-all"
        >
          Volver a mi consulta
        </button>
      </div>
    </div>
  );
};

export default PagoExitoso;
